/**
 * 充值记录
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>充值记录</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :model="formInline" class="user-search" label-width="100px">
      <el-row :gutter="5">
        <el-col :md="6" :xl="4">
          <el-form-item label="商户名称 :">
            <el-input
              size="small"
              v-model="formInline.merchantName"
              placeholder="请输入商户名称"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :md="6" :xl="4">
          <el-form-item label="处理状态 :">
            <el-select
              size="small"
              v-model="formInline.rechargeStatus"
              placeholder="请选择"
              style="width: 100%"
            >
              <el-option
                v-for="(val, index) in status_list"
                :label="val.label"
                :value="val.value"
                :key="index"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :md="8" :xl="4">
          <el-form-item label="到账时间 : ">
            <el-date-picker
              size="small"
              v-model="formInline.date"
              type="daterange"
              value-format="yyyy-MM-dd"
              :picker-options="pickerOptions"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              align="right"
              style="width: 100%"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>

        <el-col :md="4" :xl="4">
          <el-form-item label-width="30px">
            <el-button size="small" type="primary" @click="search"
              >搜索</el-button
            >
            <el-button size="small" @click="reset()">清空</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div style="margin-bottom: 10px">
      <el-button size="small" type="primary" @click="exportdata"
        >导出数据</el-button
      >
    </div>

    <!--列表-->
    <el-table
      size="small"
      :data="listData"
      highlight-current-row
      v-loading="loading"
      element-loading-text="拼命加载中"
      style="width: 100%"
    >
      <!-- <el-table-column align="center" type="selection" width="60">
      </el-table-column> -->
      <el-table-column
        fixed
        prop="rechargeId"
        label="充值ID"
        show-overflow-tooltip
      >
        <template #default="scope">
          <span @dblclick="copyToClipboard(scope.row.rechargeId)">
            {{ scope.row.rechargeId }}
          </span>
        </template>
      </el-table-column>
      <el-table-column
        prop="merchantName"
        label="商户名称"
        show-overflow-tooltip
      >
        <template #default="scope">
          <span @dblclick="copyToClipboard(scope.row.merchantName)">
            {{ scope.row.merchantName }}
          </span>
        </template>
      </el-table-column>
      <el-table-column
        prop="arrivalTime"
        label="到账时间"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="rechargeAmount"
        label="充值金额"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span>{{ scope.row.rechargeAmount.toFixed(2) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="canInvoiceAmount"
        label="可开票金额"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span>{{ scope.row.canInvoiceAmount.toFixed(2) }}</span
          ><br />
          <span class="btnNoBorderBlue" @click="getdetail(scope.row.rechargeId)"
            >金额明细</span
          >
        </template>
      </el-table-column>
      <el-table-column
        prop="rechargeStatusStr"
        label="处理状态"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column label="下发信息" show-overflow-tooltip>
        <template slot-scope="scope">
          <!-- <span class="scopeItem" v-cloak>{{
            scope.row.distributeChannelName
          }}</span
          ><br /> -->
          <span class="scopeItem" v-cloak>{{
            scope.row.distributeCompanyName
          }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="recruitmentStateDesc"
        label="付款信息"
        show-overflow-tooltip
      >
        <template #default="scope">
          <span
            @dblclick="
              copyToClipboard(scope.row.paymentAccount + scope.row.paymentName)
            "
          >
            <span class="scopeItem" v-cloak>{{ scope.row.paymentAccount }}</span
            ><br />
            <span class="scopeItem" v-cloak>{{ scope.row.paymentName }}</span>
          </span>
        </template>
      </el-table-column>
      <el-table-column
        prop="paymentRemark"
        label="付款备注"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <el-tooltip
            :content="scope.row.paymentRemark"
            placement="bottom"
            effect="light"
          >
            <span class="ellipsis">{{ scope.row.paymentRemark }}</span>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination
      v-bind:child-msg="pageparm"
      @callFather="callFather"
    ></Pagination>
    <!-- 编辑界面 -->
    <el-dialog
      :title="title"
      :visible.sync="editFormVisible"
      width="500px"
      @click="closeDialog"
    >
      <div style="background: #fafafa; border-radius: 8px; padding: 24px 42px">
        <div style="display: flex; justify-content: space-between">
          <span>充值金额：</span><span>{{ info.rechargeAmount }}</span>
        </div>
        <hr />
        <div style="display: flex; justify-content: space-between">
          <span>已开票金额：</span><span>{{ info.invoiceAmount }}</span>
        </div>
        <div style="display: flex; justify-content: space-between">
          <span>开票记录ID:</span><span>{{ info.recordId }}</span>
        </div>
        <div style="display: flex; justify-content: space-between">
          <span>开票时间:</span><span>{{ info.invoiceDate }}</span>
        </div>
        <hr />
        <div style="display: flex; justify-content: space-between">
          <span>可开票金额:</span><span>{{ info.canInvoiceAmount }}</span>
        </div>
        <div style="display: flex; justify-content: flex-end; font-size: 12px">
          可开票金额=充值金额-已开票金额-处理中金额
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  rechargeRecords,
  recordsexcel,
  getamountdetail,
} from "../../api/userMG";
import Pagination from "../../components/Pagination";
export default {
  data() {
    return {
      info: {
        rechargeAmount: "",
        recordId: "",
        invoiceDate: "",
        canInvoiceAmount: "",
      },
      status_list: [
        {
          label: "加款成功",
          value: 1,
        },
        {
          label: "挂账",
          value: 2,
        },
        {
          label: "原路退款",
          value: 3,
        },
        {
          label: "调账处理中",
          value: 4,
        },
      ],
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      nshow: true, //switch开启
      fshow: false, //switch关闭
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      title: "金额明细",
      editForm: {
        date: [],
        positionId: "",
        positionName: "",
        positionState: "",
        token: localStorage.getItem("logintoken"),
      },
      // rules表单验证
      rules: {},
      formInline: {
        page: 1,
        pageSize: 10,
        varLable: "",
        varName: "",
        startDate: "",
        endDate: "",
        merchantName: "",
        rechargeStatus: "",
        date: [],
        canInvoice: "",
      },
      // 删除部门
      seletedata: {
        ids: "",
        token: localStorage.getItem("logintoken"),
      },
      userparm: [], //搜索权限
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        page: 1,
        pageSize: 10,
        total: 10,
      },
    };
  },
  // 注册组件
  components: {
    Pagination,
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.getdata(this.formInline);
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    copyToClipboard(text) {
      if (navigator.clipboard) {
        navigator.clipboard.writeText(text).then(
          () => {
            this.$message({
              message: "已复制",
              type: "success",
            });
          },
          () => {
            this.$message.error("复制失败，请重试！");
          }
        );
      } else {
        // 兼容旧浏览器
        const input = document.createElement("textarea");
        input.value = text;
        document.body.appendChild(input);
        input.select();
        try {
          document.execCommand("copy");
          this.$message({
            message: "已复制",
            type: "success",
          });
        } catch (err) {
          this.$message.error("复制失败，请重试！");
        }
        document.body.removeChild(input);
      }
    },
    getdetail(id) {
      this.editFormVisible = true;

      getamountdetail(id).then((res) => {
        this.info = res.data;
      });
    },
    reset() {
      this.formInline = {
        page: 1,
        pageSize: 10,
        varLable: "",
        varName: "",
        startDate: "",
        endDate: "",
        merchantName: "",
        rechargeStatus: "",
        date: [],
        canInvoice: "",
      };
      this.getdata(this.formInline);
    },
    exportdata() {
      let params = {
        page: 1,
        pageSize: 99999999,
        startDate: this.formInline.date[0] || "",
        endDate: this.formInline.date[1] || "",
        merchantName: this.formInline.merchantName,
        rechargeStatus: this.formInline.rechargeStatus,
        canInvoice: this.formInline.canInvoice,
      };
      recordsexcel(params).then((res) => {
        if (res.msg == "success") {
          window.open(res.data.downloadUrl);
        } else {
          this.$message({
            type: "error",
            message: res.msg,
          });
        }
      });
    },
    // 获取公司列表
    getdata(parameter) {
      parameter.startDate = parameter.date[0] || "";
      parameter.endDate = parameter.date[1] || "";

      rechargeRecords(parameter)
        .then((res) => {
          this.loading = false;
          if (res.msg != "success") {
            this.$message({
              type: "error",
              message: res.msg,
            });
          } else {
            this.listData = res.data.items;

            // 分页赋值
            this.pageparm.page = res.data.page;
            this.pageparm.pageSize = res.data.pageSize;
            this.pageparm.total = res.data.totalCount;
          }
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.page;
      this.formInline.pageSize = parm.pageSize;
      this.getdata(this.formInline);
    },
    // 搜索事件
    search() {
      this.getdata(this.formInline);
    },
    //显示编辑界面
    handleEdit: function (index, row) {
      this.editFormVisible = true;
      if (row != undefined && row != "undefined") {
        this.title = "修改";
        this.editForm.deptId = row.deptId;
        this.editForm.deptName = row.deptName;
        this.editForm.deptNo = row.deptNo;
      } else {
        this.title = "添加";
        this.editForm.deptId = "";
        this.editForm.deptName = "";
        this.editForm.deptNo = "";
      }
    },
    // 编辑、增加页面保存方法
    submitForm(editData) {
      this.$refs[editData].validate((valid) => {
        if (valid) {
          // deptSave(this.editForm)
          //   .then(res => {
          //     this.editFormVisible = false
          //     this.loading = false
          //     if (res.success) {
          //       this.getdata(this.formInline)
          //       this.$message({
          //         type: 'success',
          //         message: '公司保存成功！'
          //       })
          //     } else {
          //       this.$message({
          //         type: 'info',
          //         message: res.msg
          //       })
          //     }
          //   })
          //   .catch(err => {
          //     this.editFormVisible = false
          //     this.loading = false
          //     this.$message.error('公司保存失败，请稍后再试！')
          //   })
        } else {
          return false;
        }
      });
    },
    // 删除公司
    deleteUser(index, row) {
      this.$confirm("确定要删除吗?", "信息", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          // deptDelete(row.deptId)
          //   .then(res => {
          //     if (res.success) {
          //       this.$message({
          //         type: 'success',
          //         message: '公司已删除!'
          //       })
          //       this.getdata(this.formInline)
          //     } else {
          //       this.$message({
          //         type: 'info',
          //         message: res.msg
          //       })
          //     }
          //   })
          //   .catch(err => {
          //     this.loading = false
          //     this.$message.error('公司删除失败，请稍后再试！')
          //   })
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    // 关闭编辑、增加弹出框
    closeDialog() {
      this.editFormVisible = false;
    },
  },
};
</script>

<style scoped>
.user-search {
  margin-top: 20px;
  margin-bottom: 10px;
  padding: 10px;
  background-color: #fff;
}
.el-form-item {
  margin-bottom: 10px !important;
}
.userRole {
  width: 100%;
}
.btnNoBorderBlue {
  cursor: pointer;
  color: #409eff;
}
</style>

 


// WEBPACK FOOTER //
// src/views/payCenter/rechargeRecord.vue